import React from 'react';
import Form from 'screens/shared/form';
import { actions } from 'redux/local';
import { VALIDATION } from 'constant';
import { _t } from 'utils';
import { withRouter } from 'react-router-dom';

export default withRouter(({ lan = {}, match }) => {
  const { id: _dcId, dcId } = match.params;
  const { id } = lan;

  const model = {
    name: '',
    public: false,
    ...lan,
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: _t('Name'),
    },
    {
      name: 'public',
      type: 'switch',
      title: `${_t('Is public')} / Internet?`,
    },
  ];

  const validations = [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.STRING,
      min: 3,
    },
  ];

  const onSave = (properties) => {
    if (id) {
      delete properties.id;
      return actions.lan.update({ dcId: dcId || _dcId, id, properties });
    }

    return actions.lan.create({ dcId: dcId || _dcId, properties });
  };

  return (
    <Form
      fields={fields}
      fieldsValues={model}
      onSubmit={onSave}
      isCancel={false}
      validations={validations}
    />
  );
});
